/*
 * @Author: zzh zzh@hopdata.cn
 * @Date: 2024-06-03 10:27:40
 * @LastEditors: zzh zzh@hopdata.cn
 * @LastEditTime: 2024-06-05 16:35:24
 * @FilePath: \officialwebsite\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import axios from 'axios'
import store from './store'
import animate from 'animate.css' 

import 'element-ui/lib/theme-chalk/index.css'
import '../src/assets/global.css'

// import VueSwiper from 'vue-awesome-swiper'
// import 'swiper/css/swiper.css'
// Vue.use(VueSwiper)
import Footers from './components/footer/footers.vue'
import Head from './components/headnav/head.vue'
Vue.component('Footers',Footers)
Vue.component('Heads',Head)
Vue.config.productionTip = false
Vue.prototype.$axios=axios;
Vue.use(ElementUI)
Vue.use(animate)





new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
